import { createComponent, ElementWithProps } from '@carvana/merch-components';
import cx from 'classnames';

export const TradeInVehicle = createComponent('div', {
  className: 'flex items-center gap-xl self-stretch'
});

export const Thumbnail = createComponent('div', {
  className: 'flex w-80 flex-col items-start rounded-lg'
});

export const VehicleDetails = createComponent('div', {
  className: 'flex flex-1 flex-col items-start gap-md'
});

export const YmmValue = createComponent('div', {
  className: 'flex flex-col items-start gap-sm self-stretch'
});

export const Badge = createComponent<
  ElementWithProps<{
    status: string;
  }>
>('div', ({ status }) => ({
  className: cx(
    'flex h-24 items-center gap-md self-stretch',
    status === 'expired' &&
      '[--badge-icon-bg:var(--background-critical)] [--badge-text-color:var(--text-critical)]',
    status === 'unavailable' &&
      '[--badge-icon-bg:var(--icon-warning)] [--badge-text-color:var(--text-warning)]',
    status === 'pending' &&
      '[--badge-icon-bg:var(--icon-informational)] [--badge-text-color:var(--text-informational)]'
  )
}));

export const BadgeIcon = createComponent('span', {
  className: 'size-md rounded-md bg-[var(--badge-icon-bg)]'
});

export const BadgeText = createComponent('span', {
  className: 'text-[var(--badge-text-color)] t-label-sm'
});

export const Ymm = createComponent('div', {
  className:
    'line-clamp-1 self-stretch overflow-hidden text-ellipsis text-text-strong t-heading-xs'
});

export const Value = createComponent('div', {
  className: 'self-stretch text-text-default t-body-sm'
});
